import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import iconSprite from '../../../assets/icon-sprite.svg';
import { fetchLoan, updateLoan } from '../../actions/p2p';

class EditLoan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loan: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { data } = this.props;
    if ((prevProps?.data?.id !== data?.id)) {
      // eslint-disable-next-line react/no-did-update-set-state
      if (!data?.id) this.setState({ loan: {} });
      else {
        fetchLoan(data?.id).then(({ data: { loan } }) => this.setState({
          loan,
          id: loan?.id,
          phone_number: loan?.user?.phone_number,
          loan_amount: loan?.loan_amount,
          interest_rate: loan?.interest_rate,
          tenor_period: loan?.tenor_period,
          duration: loan?.tenorInDays,
        }));
      }
    }
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleOnSubmit = async (e) => {
    e.preventDefault();
    const { onClose, onSubmit } = this.props;
    this.setState({ loading: 'Processing' }, async () => {
      try {
        console.log(this.state);
        const response = await updateLoan(this.state);
        
        if (response.status !== 'success') throw new Error(response?.message);
        
        toast.success(response?.message);
        onClose?.();
        onSubmit?.();
      } catch (error) {
        this.setState({ processing: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { visible, onClose = function $() { } } = this.props;
    const { loading, loan } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form
action=""
          className="modal-form"
          onSubmit={this.handleOnSubmit}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Loan</h5>
              <button type="button" className="close" onClick={onClose}>
                <svg width="48" height="48">
                  <use xlinkHref={iconSprite + '#close-icon'}></use>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <p className="modal-body__p">
                Enter details for the loan
              </p>
              <div className="form-group">
                <label htmlFor="phone" className="form-label">Phone Number</label>
                <input
                  type="number"
                  className="form-control"
                  id="phone_number"
                  name="phone_number"
                  defaultValue={loan?.user?.phone_number}
                  onChange={this.handleOnChange}
                  disabled
                  required />
              </div>
              <div className="form-group">
                <label htmlFor="loan_amount" className="form-label">Loan Amount</label>
                <input
                  type="number"
                  className="form-control"
                  id="loan_amount"
                  name="loan_amount"
                  defaultValue={loan?.loan_amount}
                  onChange={this.handleOnChange}
                  required />
              </div>
              <div className="form-group">
                <label htmlFor="interest_rate" className="form-label">Interest Rate</label>
                <input
                  type="text"
                  className="form-control"
                  id="interest_rate"
                  name="interest_rate"
                  defaultValue={loan?.interest_rate}
                  onChange={this.handleOnChange}
                  required />
              </div>
              <div className="form-group">
                <label htmlFor="tenor_period" className="form-label">Tenor Period</label>
                <div className="input-with-icon">
                  <select
                    className="form-control"
                    id="tenor_period"
                    name="tenor_period"
                    onChange={this.handleOnChange}>
                    <option disabled selected={!loan?.tenor_period}>Tenor Period</option>
                    <option value="days" selected={loan?.tenor_period == 'days'}>Days</option>
                    <option value="months" selected={loan?.tenor_period == 'months'}>Months</option>
                  </select>
                  <span className="input-icon">
                    <svg width="24" height="24">
                      <use xlinkHref={`${iconSprite}#dropdown`}></use>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="duration" className="form-label">Tenor Period</label>
                <input
                  type="number"
                  className="form-control"
                  id="duration"
                  name="duration"
                  defaultValue={loan?.tenor}
                  onChange={this.handleOnChange}
                  required />
              </div>

            </div>
            <div className="modal-footer">
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary">
                {loading || 'Update Loan'}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default EditLoan;
